import { AnyAction, combineReducers, Reducer } from "redux";
import produce from "immer";

import { createInstanceMapReducer, EMPTY_OBJECT } from "@multiweb/reactUtils";
import { ExtendedPropertiesType, TagsType } from "@multiweb/types/multiweb";
import { FormsMapState, IDeleteFormAction, IFormMappedAction, IFormState, IInitFormAction } from "./types";

const extendedProperties: Reducer<ExtendedPropertiesType> = (state = EMPTY_OBJECT, action) => {
    if (action instanceof IInitFormAction) {
        return action.payload.extendedProperties;
    }
    return state;
};

const tags: Reducer<TagsType> = (state = EMPTY_OBJECT, action) => {
    if (action instanceof IInitFormAction) {
        return action.payload.tags;
    }
    return state;
};

const formsReducer: Reducer<IFormState> = combineReducers({
    extendedProperties,
    tags,
});

const instanceKeyResolver = (action: AnyAction) => {
    return action instanceof IFormMappedAction ? action.meta.formKey : undefined;
};

const instanceMapReducer = createInstanceMapReducer(formsReducer, instanceKeyResolver);

export const reducer: Reducer<FormsMapState> = (state = EMPTY_OBJECT, action) => {
    if (action instanceof IDeleteFormAction) {
        return produce(state, (draft) => {
            delete draft[action.meta.formKey];
        });
    }

    const formKey = instanceKeyResolver(action);
    if (formKey && (state[formKey] || action instanceof IInitFormAction)) {
        return instanceMapReducer(state, action);
    }

    return state;
};
